<template>
  <div>
    <v-row align="end" justify="space-between">
      <!--  total shipments -->
      <v-col class="px-2 py-0" cols="4" md="3">
        <v-card class="stats-card mx-1 px-5 py-3 mt-2">
          <p class="sub-title-text">{{ $lang.REQUESTS }}</p>

          <v-badge
              v-if="is_new"
              bordered
              color="primary"
              dot
              overlap
          >
            <p class="status-text-filter fw-bold fs-48">{{ total_request }}</p>

          </v-badge>

          <p v-if="!is_new" class="status-text-filter fw-bold fs-48">{{ total_request }}</p>
        </v-card>
      </v-col>
      <v-col class="px-5 py-0 text-right v-align-bottom" cols="4" md="9">
        <div class="d-inline-flex pr-4">
          <span class="secodry-text-4 fs-14"> {{ $lang.AUTO_ASSIGN }}</span>
        </div>
        <div class="d-inline-flex">
          <v-switch
              v-model="is_auto_assign"
              :class="
              is_auto_assign ? 'active-toggle-btn' : 'deactive-toggle-btn'
            "
              :ripple="false"
              class="custome-toggle-btn"
              color="error"
              inset
              @click="toggleAutoAccept()"
          ></v-switch>
        </div>
        <v-btn
            class="ml-2"
            color="primary"
            text
            width="100"
            @click="getwholesaler_list2"
        >
          <v-icon>mdi-autorenew</v-icon>
          <b>{{ $lang.REFRESH }}</b>
        </v-btn>
      </v-col>
    </v-row>
    <div class="mt-3">
      <v-data-table
          :disable-sort="true"
          :headers="headers"
          :hide-default-footer="true"
          :items="wholesaler_list"
          :items-per-page="$keys.PAGE_LENGTH"
          :loading="table_loading"
          class="elevation-1 custome-header-bg custome-table-body"
          item-key="wholesaler_id"
          show-expand
          single-expand
          @item-expanded="loadShipments"
      >
        <template v-slot:item.firm_name="{ item }">
          <p>{{ item.firm_name }}</p>
          <p>{{ item.mobile }}</p>
        </template>

        <template v-slot:item.number_of_shipment="{ item }">
          <p>{{ item.shipment_count }}</p>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn
              class="br-8 border-w-2 my-3"
              color="primary"
              outlined
              @click="loadShipments('',item)"
          >
            <!-- @click="acceptShipment(item)" -->
            <b>{{ $lang.ACCEPT }}</b>
          </v-btn>
        </template>

        <template v-slot:expanded-item="{ headers }">
          <td
              :colspan="headers.length"
              class="pa-0 ma-0"
              style="height: auto !important"
          >
            <div v-if="shipment_list.length<1" class="text-center py-10 bg-transparent blue-grey lighten-5">
              <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
              ></v-progress-circular>
            </div>

            <v-simple-table v-if="shipment_list.length>0" class="blue-grey lighten-5 inner-table" dense>
              <template v-slot:default>
                <tr class="pa-2 border-b">
                  <td class="text-left pl-3 pt-2">{{ $lang.SHIPMENT_ID }}</td>
                  <td class="text-left fw-bold">{{ $lang.RETAILER_INFO }}</td>
                  <td class="text-left fw-bold">{{ $lang.CHALLAN_NUMBER }}</td>
                  <td class="text-left fw-bold">{{ $lang.AMOUNT }}</td>
                  <td class="text-left fw-bold">{{ $lang.TYPE }}</td>
                  <td class="text-left fw-bold">{{ $lang.TIMER }}</td>
                </tr>
                <tr
                    v-for="(shipment, i) in shipment_list"
                    :key="i"
                    class="border-b"
                >
                  <td class="text-left pl-3">{{ shipment.shipment_id }}</td>
                  <td class="text-left pt-2">
                    <p>{{ shipment.retailer_firm_name }}</p>
                    <p>{{ shipment.retailer_mobile_number }}</p>
                  </td>
                  <td class="pt-2">
                    <p>{{ shipment.challan_number }}</p>
                  </td>
                  <td class="pt-2">
                    <p>{{ shipment.shipment_amount }}</p>
                  </td>
                  <td class="pt-2">
                    <p>{{ shipment.payment_mode }}</p>
                  </td>
                  <td class="pt-2">
                    <timer :time_elapsed="shipment.time_elapsed"/>
                  </td>
                </tr>
              </template>
            </v-simple-table>
          </td>
        </template>

        <!-- empty slot  -->
        <template v-slot:no-data>
          <empty-list :message="$lang.EMPTY_SHIPMENTS"/>
        </template>
      </v-data-table>

      <v-pagination
          v-model="page_number"
          :length="total_page_count"
          :total-visible="7"
          class="custome-pagination"
          @input="getwholesaler_list2"
      ></v-pagination>
    </div>

    <assign-pickup-agent-dailog
        ref="assign_pickup_agent_elm"
        :dialog="dialog"
        @update-pedding-shipment-list="getwholesaler_list2"
    />
  </div>
</template>
<script type="text/javascript">

var sound_track = require('@/assets/audio/notification.mp3')
// var notification_track= new Audio('@/assets/audio/notification.mp3')
export default {
  components: {
    AssignPickupAgentDailog: () =>
        import("./child/AssignPickupAgentDailog.vue"),
    Timer: () => import("./child/Timer"),
  },
  data() {
    return {
      is_auto_assign: false,
      is_new: false,
      shipment_count: 0,
      dialog: {
        flag: false,
      },
      shipment: {},
      /* table  items*/
      page_number: 1,
      total_page_count: 1,
      wholesaler_list: [],
      shipment_list: [],
      table_loading: false,
      total_request: 0,
      headers: [
        {text: "Wholesaler Info", align: "start", value: "firm_name"},
        {
          text: "Number of Shipments",
          value: "number_of_shipment",
          align: "center",
        },
        {text: "", value: "action", align: "end"},
        {text: "", value: "data-table-expand"},
      ],
    };
  },
  created() {
    this.$store.dispatch("drawer/setActiveTab", -1);
    self.table_loading = true;
    this.$store.dispatch("setPageLoader", true);
    this.getwholesaler_list2();
    this.getwholesaler_list();
  },
  beforeRouteLeave(to, from, next) {
    let url =
        this.$urls.BASE_URL +
        this.$urls.GET_ACCEPT_SHIPMENT_LIST +
        "?page_number=" +
        this.page_number +
        "&page_length=" +
        this.$keys.PAGE_LENGTH;
    this.$polling.removeObserver(url);
    next();
  },
  methods: {
    /* fetching shipment list */
    getwholesaler_list() {
      const self = this;
      let url =
          this.$urls.BASE_URL +
          this.$urls.GET_ACCEPT_SHIPMENT_LIST +
          "?page_number=" +
          this.page_number +
          "&page_length=" +
          this.$keys.PAGE_LENGTH;
      let warehouse_id = "";
      if (self.$store.state.warehouse)
        warehouse_id = self.$store.state.warehouse.id;
      this.$polling.addObserver(url, {
        interval: this.$store.state.polling_interval,
        maxFails: 10,
        headers: {
          token: sessionStorage.getItem("token"),
          "warehouse-id": warehouse_id,
          "application-type": "web",
        },
      });
      this.$options.listeners[url] = (response) => {
        this.$store.dispatch("setPageLoader", false);
        if (response.data.success) {
          if (this.total_request < response.data.total_request)
            this.playNotificationTrack()
          this.wholesaler_list = response.data.wholesaler_list;
          this.total_request = response.data.total_request;
          this.is_auto_assign = response.data.is_auto_accept;
        }
      };
    },
    /* call this api for  first time data load and   for refesh data */
    getwholesaler_list2() {
      const self = this;
      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
      };
      const successHandler = (response) => {
        if (response.data.success) {
          this.wholesaler_list = response.data.wholesaler_list;
          this.total_page_count = response.data.total_page_count;
          this.total_request = response.data.total_request;
          this.is_auto_assign = response.data.is_auto_accept;

        }
      };
      const finallyHandler = () => {
        self.table_loading = false;
        this.$store.dispatch("setPageLoader", false);
      };
      self.request_GET(
          self,
          self.$urls.GET_ACCEPT_SHIPMENT_LIST,
          params,
          successHandler,
          null,
          null,
          finallyHandler
      );
    },

    /* call this api for  first time data load and   for refesh data */
    loadShipments(obj, item = null) {
      this.shipment_list = []
      const self = this;
      let wholesaler_id = null
      if (!item)
        wholesaler_id = obj.item.wholesaler_id
      else
        wholesaler_id = item.wholesaler_id
      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
        wholesaler_id: wholesaler_id,
      };
      const successHandler = (response) => {
        if (response.data.success) {
          self.is_new = false
          self.shipment_list = response.data.shipment_list;
          if (item)
            self.acceptShipment(item)
        }
      };
      const finallyHandler = () => {
        self.table_loading = false;
        this.$store.dispatch("setPageLoader", false);
      };
      self.request_GET(
          self,
          self.$urls.GET_ACCEPT_SHIPMENT_LIST,
          params,
          successHandler,
          null,
          null,
          finallyHandler
      );
    },
    /*  play the audio track for the notification */
    playNotificationTrack() {
      var notification_track = new Audio(sound_track)
      notification_track.addEventListener("canplaythrough", () => {
        /* the audio is now playable; play it if permissions allow */
        notification_track.play(); // the audio now can be played
      });
      this.is_new = true
    },
    /* open  dialoge  for the asigningning the pickup agents */
    acceptShipment(item) {

      let number_of_packets = 0
      for (var i = 0; i < this.shipment_list.length; i++) {
        number_of_packets += this.shipment_list[i].number_of_packets
      }

      console.log(item)
      this.dialog.flag = true;
      this.dialog.btn_loading = false;
      this.dialog.wholesaler = item.firm_name;
      this.dialog.number_of_packets = number_of_packets;
      this.dialog.wholesaler_id = item.wholesaler_id;
      this.$refs.assign_pickup_agent_elm.pickup_agent_id_list = [];
      this.$refs.assign_pickup_agent_elm.search_query = "";
      this.$refs.assign_pickup_agent_elm.getPickupAgents();
    },
    toggleAutoAccept() {
      const self = this;
      this.$store.dispatch("setPageLoader", true);
      let params = {};
      const successHandler = (response) => {
        if (response.data.success) {
          // this.is_auto_assign = !this.is_auto_assign;
        }
      };
      const finallyHandler = () => {
        this.$store.dispatch("setPageLoader", false);
      };
      self.request_GET(
          self,
          self.$urls.TOGGLE_AUTO_ACCEPT,
          params,
          successHandler,
          null,
          null,
          finallyHandler
      );


    },

  },
};
</script>